const AnimationEvents = [
  {
    type: '@ANIMATION_4',
    payload: {
      started: 0,
      toEnd: 500,
      duration: 500,
    },
  },
  {
    type: '@ANIMATION_3',
    payload: {
      started: 0,
      toEnd: 5000,
      duration: 5000,
    },
  },
  {
    type: '@ANIMATION_2',
    payload: {
      started: 0,
      toEnd: 300,
      duration: 300,
    },
  },
  {
    type: '@ANIMATION_1',
    payload: {
      started: 0,
      toEnd: 1000,
      duration: 1000,
    },
  },
];

const AnimationEventsDuration = AnimationEvents.reduce((prev, current) => prev + current.payload.duration, 0);

const TickEvent = {
  type: '@TICK',
  payload: {
    started: 0,
    toEnd: 1000,
    duration: 1000,
  },
};

export { AnimationEvents, AnimationEventsDuration, TickEvent };
